import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ReviewVerifyPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios.get(`${API}/api/reviews/verify/${token}`)
      .then(r => { setStatus("success"); setMessage(r.data.message); })
      .catch(e => {
        const detail = e.response?.data?.detail || "Verification failed";
        // Friendly message if link was already used/consumed
        if (e.response?.status === 404) {
          setStatus("error");
          setMessage("This verification link has already been used or has expired. If you've already verified, your review is live on the chef's profile.");
        } else {
          setStatus("error");
          setMessage(detail);
        }
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center pt-16 px-6">
      <div className="max-w-md w-full bg-[#0A0A0A] border border-[#D4AF37]/20 p-10 text-center">
        {status === "loading" && (
          <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto" />
        )}
        {status === "success" && (
          <>
            <CheckCircle size={44} className="text-emerald-400 mx-auto mb-4" />
            <h1 data-testid="verify-success" className="font-serif text-3xl text-white font-light mb-3">Review Published</h1>
            <p className="text-[#A0A0A0] text-sm leading-relaxed mb-6">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={44} className="text-red-400 mx-auto mb-4" />
            <h1 data-testid="verify-error" className="font-serif text-3xl text-white font-light mb-3">Verification Failed</h1>
            <p className="text-[#A0A0A0] text-sm leading-relaxed mb-6">{message}</p>
          </>
        )}
        <Link
          to="/find-a-chef"
          data-testid="verify-back-btn"
          className="inline-block border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-8 py-3 text-sm tracking-widest uppercase font-medium transition-colors"
        >
          Browse Chefs
        </Link>
      </div>
    </div>
  );
}
